import { createSlice } from '@reduxjs/toolkit'

export const vehicleTypeSlice = createSlice({
  name: 'vehicleType',
  initialState: {
    vehicleTypesOptions: []
  },
  reducers: {
    setVehicleTypes: (state, action) => {
      state.vehicleTypesOptions = action.payload
    },
  }
})

export const { setVehicleTypes } = vehicleTypeSlice.actions
export default vehicleTypeSlice.reducer